var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 22,
    viewBox: "0 0 102 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.627 4.26988H93.2538V1.47412H95.5335V0H91.627V4.26988Z",
    fill: "#121B24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.082 1.72828L101.95 0H99.9213L98.1438 1.63679V0H96.6274V4.26988H98.1438V3.51757L98.8669 2.84659L99.9213 4.26988H102L100.082 1.72828Z",
    fill: "#121B24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2266 21.9899H67.6251V9.05826C67.6251 8.57027 68.0168 8.17378 68.4988 8.17378H83.8436C84.3256 8.17378 84.7172 8.57027 84.7172 9.05826V21.9899H89.1158V4.2699H63.2266V21.9899Z",
    fill: "#121B24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.18395H11.0064C11.4885 8.18395 11.8801 8.58044 11.8801 9.06843V22.0001H16.59V9.06843C16.59 8.58044 16.9816 8.18395 17.4637 8.18395H28.4701V4.2699H0V8.18395Z",
    fill: "#121B24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6462 10.2782H36.6842L33.8623 13.135H45.0395L43.0812 15.1174C42.7598 15.4427 42.9908 15.9917 43.4427 15.9917H50.5829L53.4048 13.135H45.0495L47.0078 11.1525C47.3291 10.8272 47.0981 10.2782 46.6462 10.2782Z",
    fill: "#121B24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3838 4.2699H31.8545V8.18395H54.49C54.9721 8.18395 55.3637 8.58044 55.3637 9.06843V17.2015C55.3637 17.6895 54.9721 18.086 54.49 18.086H31.8545V22.0001H55.3838L59.5915 17.7403V8.52961L55.3838 4.2699Z",
    fill: "#121B24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.581240acb68190dfc168404c721163cd.svg";
export { ForwardRef as ReactComponent };